import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { FormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import { NeutronRatingModule } from 'neutron-star-rating';
import { AgmCoreModule } from '@agm/core';
import { NgxMaskModule } from 'ngx-mask';
import { SharedModule } from '../../../../core/modules/shared.module';
import { FuseWidgetModule } from '../../../../core/components/widget/widget.module';
import { DndModule } from 'ng2-dnd'; //Row shuffling
import { NgxPaginationModule } from 'ngx-pagination'; //Row shuffling -pagination
import { SpreadsheetAllModule } from '@syncfusion/ej2-angular-spreadsheet';
import { NgImageSliderModule } from 'ng-image-slider';

/** Common component module */
import { CommonComponentModule } from '../common/common-component.module';

//Lcoal component
//Orders
import { UsersOrdersComponent } from './orders/users/user-order-list/user-order-list.component';
import { OrdersNewComponent } from './orders/orders-new.component';
import { OrdersleftSideComponent } from './orders/sidenavs/left/left-sidenav.component';
import { OrdersBottomComponent } from './orders/sidenavs/bottom/bottom-sidenav.component';
import { ListComponent } from './orders/order-list/order-list.component';
import { AmountPopupComponent, OrderDetailsComponent } from './orders/order-list/order-details/order-details.component';
import { RequestWorkComponent } from './orders/order-list/request-work/request-work.component';
import { RequestWorkPageComponent } from './orders/order-list/request-work-page/request-work-page.component';
import { UploadToYoutubeComponent } from './orders/to-youtube/toYoutube.component';
import { ReviewComponent } from './orders/sidenavs/left/pros/review/review.component';
import { SideNavComponent } from './orders/sidenavs/left/pros/review/side-nav/sideNav.component';
import { ProListsComponent } from './orders/sidenavs/left/pros/review/pro-list/proList.component';
import { UserInfoComponent } from './orders/sidenavs/left/pros/user-info/list/userInfo.component';
import { UserInfoMainComponent } from './orders/sidenavs/left/pros/user-info/userInfoMain.component';
import { ProUserDetailComponent } from './orders/sidenavs/left/pros/user-info/details/detail.component';
import { BasicInfoComponent } from './orders/sidenavs/left/pros/user-info/details/tabs/basic-info/basicInfo.component';
import { CredibilityComponent } from './orders/sidenavs/left/pros/user-info/details/tabs/credibility-center/credibility.component';
import { ProReferenceComponent } from './orders/sidenavs/left/pros/user-info/details/tabs/credibility-center/pro-reference/proReference.component';
import { QuestionaireComponent } from './orders/sidenavs/left/pros/user-info/details/tabs/credibility-center/questionaire/questionaire.component';
import { SkillsComponent } from './orders/sidenavs/left/pros/user-info/details/tabs/skills/skills.component';
import { EmailPopupComponent } from './solutionForm/email-popup/emailPopup.component';
import { ConfirmDialogComponent } from './solutionForm/confirm-dialog/confirm-dialog.component';

/** Assign pro component */
import { AssignProComponent } from './assignPro/assignPro.component';
import { ProListComponent } from './assignPro/pro-list/proList.component';
import { AfterAssignedComponent } from './assignPro/after-assigned/afterAssigned.component';

//Order
import { FuseEcommerceOrderComponent } from './order/order.component';

//Solution form
import { SolutionFormComponent } from './solutionForm/solutionForm.component';
import { OrderDetailsSidenavComponent } from './solutionForm/spekwo-type/after-client-accept-list/order-details/orderDetails.component';
import { SolutionMainComponent } from './solutionForm/spekwo-type/after-client-accept-list/solution-main/solutionMain.component';
import { ToggledListComponent } from './solutionForm/spekwo-type/after-client-accept-list/toggled-list/toggledList.component';
import { SpekwoComponent } from './solutionForm/spekwo-type/spekwo.component';
import { WalkCallMainComponent } from './solutionForm/walk-call/walkCallMain.component';
import { WalkCallBodyComponent } from './solutionForm/walk-call/walk-call-body/walkCallBody.component';
import { EditComponent } from './solutionForm/walk-call/walk-call-body/list-reports/edit/edit.component';
import { ListReportComponent } from './solutionForm/walk-call/walk-call-body/list-reports/listReports.component';

//Popup component
import { printDialogComponent } from './printDialog/printDialog.component';
import { EditFormDialogComponent } from './solutionForm/spekwo-type/edit-model/editForm.component';
import { printImageComponent } from './solutionForm/spekwo-type/preview-image/preview-image.component';
import { AddSubCategoryPopupComponent } from './solutionForm/walk-call/walk-call-body/add-subcategory/addSubCategory.component';
import { ProJobDetailsComponent } from './orders/order-list/pro-job-details/pro-job-details.component';
import { MaterialsPopUpComponent } from './orders/order-list/materials-pop-up/materials-pop-up.component';
//Pipe module
import { PipesModule } from '../pipesFiles/pipes.module';

//Service file
import { EcommerceOrdersService } from './orders/orders.service';
import { CommonOrdersService } from './orders/commonOrders.service';
import { EcommerceOrderService } from './order/order.service';
import { SolutionFormService } from './solutionForm/solutionForm.service';
import { AuthService } from '../authentication/auth.service';
import { AssignProService } from './assignPro/assignPro.service';
import { CalendarService } from '../calendar/calendar.service';
import { SideNavService } from './orders/sidenavs/sidenav.service';
import { ArchivedOrdersServiceService } from './orders/sidenavs/left/operations/archived-orders-list/archived-orders-service.service';
import { FuseCopierService } from '../../../../core/services/copier.service';
import { MatDialogModule } from '@angular/material/dialog'; 
import { MatTabsModule } from '@angular/material/tabs'; 
import { MatCardModule } from '@angular/material/card'; 
import { MatChipsModule } from '@angular/material/chips'; 
import { MatTooltipModule } from '@angular/material/tooltip';
  
//Local pipe file
import { RemovePipe } from '../pipesFiles/removeChar.pipe';

//Query file
import {
  UserQueryService,
  ScheduleQueryService,
  BookingsQueryService,
  RatingQueryService,
  SettingQueryService,
  OcrDumpsQueryService,
  ReportReviewQueryService,
  CategoriesQueryService,
  SolutionMasterQueryService,
  InsReportSrcQueryService,
  WalkCallQueryService,
  WCSubCategoriesQueryService,
  WCCategoriesQueryService,
  QualityReferenceQueryService,
  PersonalityReferenceQueryService,
  PicStoriesQueryService,
  StripeInvoiceQueryService,
  CommonQueryService,
  CompaniesQueryService,
  TestimonialsQueryService,
  SolutionDescriptionQueryService,
  KpiQueryService,
  ConfigurationQueryService
} from '../queryFiles/index';

// Components
import { ArchivedOrdersListComponent } from './orders/sidenavs/left/operations/archived-orders-list/archived-orders-list.component';
import { CustomerToggleRequestComponent } from './orders/sidenavs/left/operations/customer-toggle-request/customer-toggle-request.component';
import { DetailDialogComponent } from './orders/sidenavs/left/operations/detail-dialog/detail-dialog.component';
import { CompanyServeComponent } from './orders/sidenavs/left/operations/manage-references/company-serve/company-serve.component';
import { ManageReferencesComponent } from './orders/sidenavs/left/operations/manage-references/manage-references.component';
import { TestimonialsComponent } from './orders/sidenavs/left/operations/manage-references/testimonials/testimonials.component';
import { SolutionDescriptionComponent } from './orders/sidenavs/left/operations/solution-description/solution-description.component';
import { SpekwoSolutionDescriptionComponent } from './orders/sidenavs/left/operations/solution-description/create-solution-description/create-solution-description.component';
import { SolutionListComponent } from './orders/sidenavs/left/operations/solution-description/solution-list/solution-list.component';
import { EditSolutionComponent } from './orders/sidenavs/left/operations/solution-description/edit-solution-description/edit-solution.component';
import { SolutionDescriptionFormComponent } from './orders/sidenavs/left/operations/solution-description/solution-description-form/solution-description-form.component';
import { SearchSolutionDescriptionComponent } from './orders/sidenavs/left/operations/solution-description/search-solution-description/search-solution-description.component';
import { KpiComponent } from './orders/sidenavs/left/operations/kpi/kpi.component';
import { KpiSheetViewComponent } from './orders/sidenavs/left/operations/kpi/kpi-sheet-view/kpi-sheet-view.component';
import { KpiFormViewComponent } from './orders/sidenavs/left/operations/kpi/kpi-form-view/kpi-form-view.component';
import { SolutionEstimateUsersQueryService } from '../queryFiles/solutionEstimateUsers';
import { PreListPopUpComponent } from './orders/order-list/pre-list-pop-up/pre-list-pop-up.component';
import { CommonTableComponent } from './common-table/common-table.component';
import { CommonSaveTableComponent } from './common-save-table/common-save-table.component';
import { PreListPrintComponent } from './orders/order-list/pre-list-print/pre-list-print.component';
import { PrintSchedulingInfoComponent } from './orders/order-list/print-scheduling-info/print-scheduling-info.component';
import { OrderEditComponent } from './orders/order-list/order-edit/order-edit.component';
import { OrderDetailsEditComponent } from './orders/order-list/order-details-edit/order-details-edit.component';
// import { AmountPopupComponent, OrderDetailsInfoComponent } from './orders/order-list/order-details-info/order-details-info.component';
import { NgxDaterangepickerMd } from 'ngx-daterangepicker-material';
import { ConfigurationService } from '../configuration/configuration.service';
import { PreviewSupportingInfoComponent } from './solutionForm/spekwo-type/preview-supporting-info/preview-supporting-info.component';
import { PermissonCheckGuard } from '../../../../guard/permisson-check.guard';
import { OrdersEditNewComponent } from './orders/order-list/orders-edit-new/orders-edit-new.component';
import { OrderDetailsNewComponent } from './orders/order-list/order-details-new/order-details-new.component';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { SolutionDescriptionAuditLogComponent } from './orders/sidenavs/left/operations/solution-description/solution-description-audit-log/solution-description-audit-log.component';
import { OrderListAuditComponent } from './orders/order-list/order-list-audit/order-list-audit.component';
import { CrmFlowComponent } from './orders/sidenavs/left/operations/crm-flow/crm-flow.component';
import { CustomerDetailsDialogComponent } from './orders/sidenavs/left/operations/crm-flow/customer-details-dialog/customer-details-dialog.component';

const routes: Routes = [
  {
    path: 'orders',
    component: OrdersNewComponent,
    resolve: {
      data: EcommerceOrdersService,
      authService: AuthService,
      common: CommonOrdersService
    },
  },
  {
    path: 'orders/:id',
    component: FuseEcommerceOrderComponent,
    resolve: {
      data: EcommerceOrderService,
      solutionForm: SolutionFormService
    },
    canActivate: [PermissonCheckGuard],
  },
  {
    path: 'ordersdetails/:id',
    component: OrdersEditNewComponent,
    resolve: {
      solutionForm: SolutionFormService,
      authService: AuthService,
      order: EcommerceOrdersService,
      // common: CommonOrdersService,
    },
    canActivate: [PermissonCheckGuard],
  },
  {
    path: 'proJobDetails/:id',
    component: ProJobDetailsComponent,
    resolve: {
      solutionForm: SolutionFormService,
      order: EcommerceOrdersService,
    },
    canActivate: [PermissonCheckGuard],
  },
  {
    path: 'requestwork/:id',
    component: RequestWorkPageComponent,
    resolve: {
      data: EcommerceOrderService,
      order: EcommerceOrdersService,
      solutionForm: SolutionFormService
    },
    canActivate: [PermissonCheckGuard],
  },
  {
    path: 'pro-solution-estimate/:id/:insReportId/:pageType',
    component: SolutionMainComponent,
    canActivate: [PermissonCheckGuard],
  },
  {
    path: 'approve-solution-estimate/:id/:insReportId/:pageType',
    component: SolutionMainComponent,
    canActivate: [PermissonCheckGuard],
  },
  {
    path: 'archivedOrders',
    component: ArchivedOrdersListComponent,
    resolve: {
      archivedOrders: ArchivedOrdersServiceService,
      data: EcommerceOrderService,
    },
    canActivate: [PermissonCheckGuard],
  },
  {
    path: 'customerToggle',
    component: CustomerToggleRequestComponent,
    resolve: {
      sideNavService: SideNavService
    },
    canActivate: [PermissonCheckGuard],
  },
  {
    path: 'crmFlow',
    component: CrmFlowComponent,
    resolve: {
      sideNavService: SideNavService
    },
    canActivate: [PermissonCheckGuard],
  },
  {
    path: 'solutionForm/:id',
    component: SolutionFormComponent,
    resolve: {
      data: EcommerceOrderService,
      solutionForm: SolutionFormService
    },
    canActivate: [PermissonCheckGuard],
  },
  {
    path: 'solutionForm/view/:id',
    component: SolutionFormComponent,
    resolve: {
      data: EcommerceOrderService,
      solutionForm: SolutionFormService
    },
    canActivate: [PermissonCheckGuard],
  },
  {
    path: 'orders/assign/:id',
    component: AssignProComponent,
    resolve: {
      assign: AssignProService,
      calendar: CalendarService
    },
    canActivate: [PermissonCheckGuard],
  },
  {
    path: 'orders/review/all',
    component: ReviewComponent,
    resolve: {
      assign: AssignProService,
      sideNav: SideNavService
    },
    canActivate: [PermissonCheckGuard],
  },
  {
    path: 'userInfo',
    component: UserInfoMainComponent,
    resolve: {
      assign: AssignProService,
      sideNav: SideNavService
    },
    canActivate: [PermissonCheckGuard],
  },
  {
    path: 'manage-references',
    component: ManageReferencesComponent,
    canActivate: [PermissonCheckGuard],
  },
  {
    path: 'solution-description',
    component: SolutionDescriptionComponent,
    canActivate: [PermissonCheckGuard],
  },
  {
    path: 'kpi',
    component: KpiComponent,
    canActivate: [PermissonCheckGuard],
  }

];

@NgModule({

  imports: [
    SharedModule,
    RouterModule.forChild(routes),
    FuseWidgetModule,
    NgxChartsModule,
    NeutronRatingModule,
    NgImageSliderModule,
    AgmCoreModule.forRoot({
      apiKey: 'AIzaSyD81ecsCj4yYpcXSLFcYU97PvRsE_X8Bx8'
    }),
    FormsModule,
    HttpModule,
    NgxMaskModule.forRoot(),
    DndModule.forRoot(), //Row shuffling
    NgxPaginationModule, //Row shuffling pagination
    PipesModule,
    CommonComponentModule,
    SpreadsheetAllModule,
    NgxDaterangepickerMd.forRoot(),
    MatDialogModule,
    MatTabsModule,
    MatCardModule,
    MatChipsModule,
    MatTooltipModule

  ],
  declarations: [
    UsersOrdersComponent,
    OrdersNewComponent,
    OrdersleftSideComponent,
    OrdersBottomComponent,
    ListComponent,
    OrderDetailsComponent,
    RequestWorkComponent,
    RequestWorkPageComponent,
    UploadToYoutubeComponent,
    AssignProComponent,
    ProListComponent,
    AfterAssignedComponent,
    ReviewComponent,
    SideNavComponent,
    ProListsComponent,
    UserInfoComponent,
    UserInfoMainComponent,
    ProUserDetailComponent,
    BasicInfoComponent,
    CredibilityComponent,
    ProReferenceComponent,
    QuestionaireComponent,
    SkillsComponent,
    EmailPopupComponent,
    ConfirmDialogComponent,

    FuseEcommerceOrderComponent,

    SolutionFormComponent,
    OrderDetailsSidenavComponent,
    SolutionMainComponent,
    ToggledListComponent,

    WalkCallMainComponent,
    WalkCallBodyComponent,
    SpekwoComponent,
    ListReportComponent,

    printDialogComponent,
    EditFormDialogComponent,
    printImageComponent,
    AddSubCategoryPopupComponent,
    EditComponent,
    AmountPopupComponent,

    ArchivedOrdersListComponent,

    CustomerToggleRequestComponent,
    DetailDialogComponent,

    CompanyServeComponent,
    TestimonialsComponent,
    ManageReferencesComponent,
    SolutionDescriptionComponent,
    SpekwoSolutionDescriptionComponent,
    SolutionListComponent,
    EditSolutionComponent,
    SolutionDescriptionFormComponent,
    SearchSolutionDescriptionComponent,
    KpiComponent,
    KpiSheetViewComponent,
    KpiFormViewComponent,
    PreListPopUpComponent,
    CommonTableComponent,
    CommonSaveTableComponent,
    PreListPrintComponent,
    PrintSchedulingInfoComponent,
    OrderEditComponent,
    OrderDetailsEditComponent,
    ProJobDetailsComponent,
    MaterialsPopUpComponent,
    PreviewSupportingInfoComponent,
    OrdersEditNewComponent,
    OrderDetailsNewComponent,
    SolutionDescriptionAuditLogComponent,
    OrderListAuditComponent,
    CrmFlowComponent,
    CustomerDetailsDialogComponent
    // OrderDetailsInfoComponent
  ],
  providers: [
    //Local service file
    EcommerceOrdersService,
    CommonOrdersService,
    EcommerceOrderService,
    SolutionFormService,
    AuthService,
    AssignProService,
    CalendarService,
    SideNavService,
    ArchivedOrdersServiceService,

    //Query file
    UserQueryService,
    ScheduleQueryService,
    BookingsQueryService,
    RatingQueryService,
    SettingQueryService,
    OcrDumpsQueryService,
    ReportReviewQueryService,
    SolutionEstimateUsersQueryService,
    CategoriesQueryService,
    SolutionMasterQueryService,
    InsReportSrcQueryService,
    WalkCallQueryService,
    WCSubCategoriesQueryService,
    WCCategoriesQueryService,
    QualityReferenceQueryService,
    PersonalityReferenceQueryService,
    PicStoriesQueryService,
    StripeInvoiceQueryService,
    CommonQueryService,
    CompaniesQueryService,
    TestimonialsQueryService,
    SolutionDescriptionQueryService,
    KpiQueryService,
    ConfigurationService,
    ConfigurationQueryService,
    //Local pipe file
    RemovePipe,

    FuseCopierService,
    { provide: MatDialogRef, useValue: {} }, { provide: MAT_DIALOG_DATA, useValue: {} },


  ],
  entryComponents: [
    printDialogComponent,
    EditFormDialogComponent,
    printImageComponent,
    AddSubCategoryPopupComponent,
    EditComponent,
    EmailPopupComponent,
    AmountPopupComponent,
    ConfirmDialogComponent,
    EditSolutionComponent,
    DetailDialogComponent,
    PreListPopUpComponent,
    PreListPrintComponent,
    PrintSchedulingInfoComponent,
    OrderEditComponent,
    OrderDetailsEditComponent,
    MaterialsPopUpComponent,
    PreviewSupportingInfoComponent,
    OrdersEditNewComponent,
    SolutionDescriptionAuditLogComponent,
    OrderListAuditComponent,
    CustomerDetailsDialogComponent
  ]

})
export class FuseEcommerceModule {
}



// WEBPACK FOOTER //
// /vercel/path0/src/app/main/content/apps/e-commerce/e-commerce.module.ts